
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/marketplace/bitrix24",
      function () {
        return require("private-next-pages/[locale]/marketplace/bitrix24.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/marketplace/bitrix24"])
      });
    }
  